import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import TrendPage from "@/pages/TrendPage";
import CoreUpdatesPage from "@/pages/CoreUpdatesPage";
import ExpertsPage from "@/pages/ExpertsPage";
import AIWatchPage from "@/pages/AIWatchPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import BookmarksPage from "@/pages/BookmarksPage";
import NewsletterPage from "@/pages/NewsletterPage";
import SubscriptionPage from "@/pages/SubscriptionPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminBlogPage from "@/pages/AdminBlogPage";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] text-white/50 font-mono text-sm">
        chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/abonnement" element={<SubscriptionPage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/dashboard/trend" element={<Protected><TrendPage /></Protected>} />
      <Route path="/dashboard/core-updates" element={<Protected><CoreUpdatesPage /></Protected>} />
      <Route path="/dashboard/experts" element={<Protected><ExpertsPage /></Protected>} />
      <Route path="/dashboard/ai-watch" element={<Protected><AIWatchPage /></Protected>} />
      <Route path="/dashboard/bookmarks" element={<Protected><BookmarksPage /></Protected>} />
      <Route path="/dashboard/newsletter" element={<Protected><NewsletterPage /></Protected>} />
      <Route path="/dashboard/admin/blog" element={<Protected><AdminBlogPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
